import { render, staticRenderFns } from "./CustomerTransfers.vue?vue&type=template&id=0e76eaed&"
import script from "./CustomerTransfers.vue?vue&type=script&lang=js&"
export * from "./CustomerTransfers.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTransfers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports